import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import UITheme from "./layout/UITheme";
import reportWebVitals from './reportWebVitals';
const BASE_URL = process.env.REACT_APP_BACKEND_URL;
console.log("backend URL")
console.log(BASE_URL)
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <UITheme>
            <App/>
        </UITheme>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
